import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from '@app/components/shared/button/button';
import { HeaterPendingAudit } from '@app/models/heaters';

@Component({
  selector: 'app-expanded-component-audit-pending',
  imports: [CommonModule, Button],
  templateUrl: './expanded-component.html',
  styleUrl: './expanded-component.css',
})
export class ExpandedComponent {
  @Input() row!: HeaterPendingAudit;

  @Output() onClose = new EventEmitter<void>();
  @Output() onApprove = new EventEmitter<HeaterPendingAudit>();
  @Output() onDeny = new EventEmitter<HeaterPendingAudit>();

  handleClose() {
    this.onClose.emit();
  }

  handleApprove() {
    this.onApprove.emit(this.row);
  }

  handleDeny() {
    this.onDeny.emit(this.row);
  }
}
